import { defineChain } from 'viem';
import { MARKET } from './market.generated';

export const robinhoodTestnet = defineChain({
  id: MARKET.chainId,
  name: 'Robinhood Chain Testnet',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: { default: { http: [MARKET.rpc] } },
  blockExplorers: { default: { name: 'Explorer', url: MARKET.explorer } },
  contracts: { multicall3: { address: MARKET.multicall3 } },
  testnet: true,
});

/** Read-only: the keeper mirrors Chainlink answers published on mainnet. Nothing is ever sent there. */
export const robinhoodMainnet = defineChain({
  id: MARKET.mainnet.chainId,
  name: 'Robinhood Chain',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: { default: { http: [MARKET.mainnet.rpc] } },
  contracts: { multicall3: { address: MARKET.multicall3 } },
});
